var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 90,
    viewBox: "0 0 67 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5613 5.96212C26.7881 2.41803 23.0826 -0.448615 18.5314 0.0583325C14.4599 0.510721 8.41522 2.02474 4.29371 6.98965C0.0630868 12.0887 -1.51459 20.0407 1.73397 31.9551C5.20304 44.6652 10.3544 57.1957 16.7583 67.3051C23.1144 77.3417 30.9437 85.3756 39.9255 88.4559C47.8685 91.1794 53.9428 90.0427 58.3734 87.051C62.6473 84.1662 64.9933 79.8265 66.2073 76.8211C67.5667 73.4566 66.671 69.9535 64.8978 67.371L58.3575 57.8595C56.9127 55.7577 54.8326 54.1741 52.4221 53.3408C50.0116 52.5074 47.3976 52.4681 44.9632 53.2287L35.9245 56.0545C35.639 56.1517 35.3312 56.1633 35.0391 56.0877C34.7471 56.0122 34.4835 55.8529 34.2809 55.6294C30.2572 50.9168 25.7492 44.3447 24.5239 37.693C24.4847 37.5153 24.5113 37.3295 24.5989 37.1701C25.9288 34.9354 28.218 32.403 30.4936 30.1865C34.3514 26.431 35.8131 20.4613 33.267 15.3736L28.5613 5.96212Z",
    fill: "url(#paint0_linear_340_12939)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_12939",
    x1: 0,
    y1: 0,
    x2: 67,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B665C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B2A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNo);
export default __webpack_public_path__ + "static/media/ContactNo.04c2a7554c9c16a17a5ed3c3a69c848f.svg";
export { ForwardRef as ReactComponent };